import Vue from 'vue'
import Router from 'vue-router'
import { Loading } from 'element-ui'

//文件引入处

const login = () => import('../components/login.vue');
const product = () => import('../components/product.vue');
const nofound = () => import('../components/NotFoundComponent.vue');
const SmartBin = () => import( '../components/Smartbin/smartbin.vue');
const Operation = () => import('../components/SmartBin/SmartBin_submodule/Operation.vue');
const Device = () => import('../components/SmartBin/SmartBin_submodule/Device.vue');
const Performance = () => import('../components/SmartBin/SmartBin_submodule/Performance.vue');

const Analysis = resolve => {

  let loadingInstance = Loading.service({
    lock: true,
    text: '报表插件加载中，请稍后',
    spinner: 'el-icon-loading',
    background:"rgba(0,0,0,.5)"
  });

  require.ensure(['../components/SmartBin/SmartBin_submodule/Analysis.vue'], () => {
    resolve(require('../components/SmartBin/SmartBin_submodule/Analysis.vue'));
    loadingInstance.close();
  })
}

import WellLid from '@/components/wellLid/wellLid.vue'
import WellLid1 from '@/components/wellLid/wellLid1.vue'
import WellLid2 from '@/components/wellLid/wellLid2.vue'
import RoadSign from '@/components/RoadSign/RoadSign.vue'
import Wendu from '@/components/wenduji/wendu.vue'
import WenduE from '@/components/wenduji/wenduE.vue'
import test from '@/components/test/test.vue'


import Parking from '../components/parking/parking.vue'






Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'login',
            component: login
    },
        {
            path: '/product',
            name: 'product',
            component: product,
            meta: {
                requireAuth: true
            }
    },
        {
            path: '/SmartBin',
            name: 'SmartBin',
            component: SmartBin,
            redirect: '/SmartBin/Operation',
            meta: {
                requireAuth: true
            },
            children: [
                {
                    path: '/SmartBin/Operation',
                    name: 'Operation',
                    component: Operation,
                    meta: {
                        requireAuth: true
                    }

        }, {
                    path: '/SmartBin/Device',
                    name: 'Device',
                    component: Device,
                    meta: {
                        requireAuth: true
                    }

        }, {
                    path: '/SmartBin/Performance',
                    name: 'Performance',
                    component: Performance,
                    meta: {
                        requireAuth: true
                    }

        }, {
                    path: '/SmartBin/Analysis',
                    name: 'Analysis',
                    component: Analysis,
                    meta: {
                        requireAuth: true
                    }

        }
      ]
    },
      {
        path: '/WellLid',
        name: 'WellLid',
        component: WellLid1,
        meta: {
          requireAuth: true
        }
      },


      {
        path: '/RoadSign',
        name: 'RoadSign',
        component: RoadSign,
        meta: {
          requireAuth: true
        }
      },
            {
              path: '/Parking',
              name: 'parking',
              component: Parking,
              meta: {
                requireAuth: true
              }
            },
            {
              path: '/Wendu',
              name: 'Wendu',
              component: Wendu,
              meta: {
                requireAuth: true
              }
            }, {
              path: '/WenduE',
              name: 'WenduE',
              component: WenduE,
              meta: {
                requireAuth: true
              }
            },
      {
        path: '/test',
        name: 'test',
        component: test,
      },{
        path: '*',
        name: 'nofound',
        component: nofound,
      }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js